import IPLYearsCarousel from "@/component/IPL/IPLYearsCarousel";
import OrangeCapTable from "@/component/IPL/OrangeCapTable";
import TopPlayerCard from "@/component/IPL/TopPlayerCard";
import { getDataFromSSR } from "@/handlers/client/commonClient";
import dynamic from "next/dynamic";
import {
  apstagBidCallback,
  createApsSlotsRosDesktop,
  createApsSlotsRosMobile,
  requestBiddingFromPWT,
} from "@/utils/ads";

import { useRouter } from "next/router";
import { useContext, useEffect, useState } from "react";
import { MasterConfigContext } from "@/context/MasterConfigContext";
import IPLSponsor from "@/component/IPL/IPLSponser";
const AdSlot300x250 = dynamic(() => import("@/component/Ads/AdSlot300x250"));
const AdSlot728x90 = dynamic(() => import("@/component/Ads/AdSlot728x90"));
const MGIDAAdsScript = dynamic(() => import("@/component/Ads/MGIDAdsScript"));
 
const HeadTag = dynamic(() => import("@/component/SeoTags/HeadTag"));
const GTMScript = dynamic(() => import("@/component/Ads/GTMScript"));
const Breadcrumb = dynamic(() => import("@/component/Breadcrumb"));
const BreadcrumbSchema = dynamic(() =>
  import("@/component/SeoTags/BreadcrumbSchema")
);
const ItemsList = dynamic(() => import("@/component/SeoTags/ItemsList"));
const WebpageSchema = dynamic(() =>
  import("@/component/SeoTags/WebpageSchema")
);
// const WebsiteSchema = dynamic(() =>
//   import("@/component/SeoTags/WebsiteSchema")
// );
// const IPLFAQSchema = dynamic(() => import("@/component/SeoTags/IPLFAQSchema"));
const IPLMenu = dynamic(() => import("@/component/IPL/IPLMenu"));
const IPLCommonFooter = dynamic(() =>
  import("@/component/IPL/IPLCommonFooter")
);

const OrangeCapPage = ({
  categoryNewsListData = null,
  isMobileDevice = false,
  faqData = null,
  year = 2025,

  statsData = null,
}) => {
  const iplYearsFilter = {
    2025: "8307",
    2024: "5970",
    2023: "5157",
    2022: "4623",
    2021: "4165",
    2020: "3978",
    2019: "3130",
    2018: "2940",
  };
  const battingFilter = [
    "Most Runs",
    "Best Individual Score",
    "Best Batting Average",
    "Best Strike Rate",
    "Most 100s",
    "Most 50s",
    "Most 6s",
    "Most 4s",
  ];

  const [selectedYear, setSelectedYear] = useState(year);
  const [tourId, setTourId] = useState(iplYearsFilter[year || selectedYear]); //2024 tour id
  const [selectedBattingFilter, setBattingFilter] = useState(battingFilter[0]);
  const handleSelectYear = (year) => {
    setSelectedYear(year);
  };
  const handleDropdownChange = (e) => {
    setBattingFilter(e.target.value);
  };

  const [statData, setStatData] = useState([]);
  const [searchByName, setSearchByName] = useState("");
  const [readMore, setReadMore] = useState(true);
  useEffect(() => {
    const getStatsData = async () => {
      const websiteUrl = process.env.NEXT_PUBLIC_WEBSITE_URL;
      let data = await getDataFromSSR(
        `${websiteUrl}/api/getStatsAPI?tourID=${tourId}&statsId=10`
      );
      // console.log("orange",data)
      const newLeaderboard = data?.data?.data?.leaderboard || [];
      setStatData(newLeaderboard);
    };

    getStatsData();
  }, [year, tourId]);

  useEffect(() => {
    if (!statsData) return;

    const fullLeaderboard = statsData?.leaderboard || [];

    setStatData(
      searchByName
        ? fullLeaderboard.filter((value) =>
            value.player_name.toLowerCase().includes(searchByName.toLowerCase())
          )
        : fullLeaderboard
    );
  }, [searchByName, statsData]);
  // ads implement
  const router = useRouter();
  const currentPath = router?.asPath?.split("?")[0];
  const keyBindings = {
    Category:
      currentPath.split("/").length > 2
        ? [currentPath.split("/")[1], currentPath.split("/")[2]]
        : currentPath.split("/")[1],
    Keywords: categoryNewsListData?.seo_detail?.meta_keyword.split(","),
  };
  const [scrolled, setScrolled] = useState(true);
  // useEffect(() => {
  //   async function onFirstScroll() {
  //     if (!scrolled) {
  //       setScrolled(true);
  //     }
  //   }

  //   function handleScroll() {
  //     onFirstScroll();

  //     window.removeEventListener("scroll", handleScroll);
  //   }

  //   window.addEventListener("scroll", handleScroll);
  // }, []);
  // ads

  useEffect(() => {
    setTimeout(() => {
      window.googletag = window.googletag || { cmd: [] };

      if (window.screen.width < 900) {
        googletag.cmd.push(function () {
          if (scrolled) {
            googletag.destroySlots();
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_ATF_300x250",
                [300, 250],
                "div-gpt-ad-1659434453897-0"
              )
              .addService(googletag.pubads());
          }

          if (scrolled) {
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_MTF_1_300x250",
                [300, 250],
                "div-gpt-ad-1659434604998-0"
              )
              .addService(googletag.pubads());

            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_MTF-2_300x250",
                [300, 250],
                "div-gpt-ad-1659434785315-0"
              )
              .addService(googletag.pubads());

            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_BTF_300x250",
                [300, 250],
                "div-gpt-ad-1659435474737-0"
              )
              .addService(googletag.pubads());
          }
          scrolled &&
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_Bottom_320x50",
                [320, 50],
                "div-gpt-ad-1659435612077-0"
              )
              .addService(googletag.pubads());

          // googletag.pubads().enableSingleRequest();
          googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          Object.keys(keyBindings).forEach((key) => {
            googletag.pubads().setTargeting(key, keyBindings[key]);
          });
          scrolled &&
            googletag?.cmd.push(function () {
              var INTERSTITIALAd = googletag
                ?.defineOutOfPageSlot(
                  "/1007232/News_tak_Mobile_HP_Mweb_Interstitial",
                  googletag?.enums.OutOfPageFormat.INTERSTITIAL
                )
                ?.addService(googletag.pubads());
              INTERSTITIALAd && googletag?.display(INTERSTITIALAd);
            });
        });
      } else {
        googletag.cmd.push(function () {
          if (scrolled) {
            googletag.destroySlots();
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_ATF_728x90",
                [728, 90],
                "div-gpt-ad-1659424515060-0"
              )
              .addService(googletag.pubads());

            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_ATF_300x250",
                [300, 250],
                "div-gpt-ad-1707804176041-1"
              )
              .addService(googletag.pubads());
          }
          if (scrolled) {
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_MTF_1_728x90",
                [728, 90],
                "div-gpt-ad-1707804176041-2"
              )
              .addService(googletag.pubads());
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_MTF_2_728x90",
                [728, 90],
                "div-gpt-ad-1707804176041-3"
              )
              ?.addService(googletag.pubads());
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_BTF_728x90",
                [728, 90],
                "div-gpt-ad-1659425743360-0"
              )
              .addService(googletag.pubads());
          }
          // googletag.pubads().enableSingleRequest();
          googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          Object.keys(keyBindings).forEach((key) => {
            googletag.pubads().setTargeting(key, keyBindings[key]);
          });
        });
      }
      if (scrolled) {
        apstag?.fetchBids(
          {
            slots:
              window.screen.width < 900
                ? createApsSlotsRosMobile({ mtf2: false, mtf3: false })
                : createApsSlotsRosDesktop({ mtf2: false, mtf3: false }),
            timeout: 2e3,
          },
          apstagBidCallback
        );
      }
    }, 10);
  }, [scrolled]);
  const masterConfig = useContext(MasterConfigContext);
  const iplKeys = masterConfig["ipl_2025"];

  const title =
    year == 2025
      ? "IPL 2025 Orange Cap: Most Runs & Top Scorers Leaderboard – NewsTak"
      : `Orange Cap Winner IPL ${year}: ${statData[0]?.player_name}, Most Runs for ${statData[0]?.team_short_name} - NewsTak`;
  const description =
    year == 2025
      ? "Get the IPL 2025 Orange Cap race with the latest list of highest run-scorers this season, updated after every match with live stats & rankings."
      : `Who won the Orange Cap in IPL ${year}? ${statData[0]?.player_name} from ${statData[0]?.team_name} wins the IPL ${year} Orange Cap for scoring the most runs. Check full season stats, match-wise scores & runner-ups list.`;
  const keywords =
    year == 2025
      ? "IPL 2025 Orange Cap, Orange Cap Winner IPL 2025, IPL 2025 Most Runs, Top Run Scorers IPL 2025, Orange Cap List Today, IPL 2025 Batting Rankings, Orange Cap Holder 2025, IPL 2025 Top Batsmen"
      : `Orange Cap Winner IPL ${year}, IPL ${year} Orange Cap Holder, Most Runs in IPL ${year}, ${statData[0]?.player_name} IPL ${year} Stats, IPL ${year} Batting Leaderboard, Who got Orange Cap in IPL ${year}, IPL ${year} Top Run Scorer, IPL ${year} Orange Cap List`;
  const canonical =
    year == 2025
      ? "/sports/ipl/orange-cap"
      : `/sports/ipl/orange-cap-winner-${year}`;

  const breadCrumbs = [
    {
      id: "1",
      title: "Sports",
      canonical_url: "/sports",
      amp_url: "",
    },
    {
      id: "2",
      title: "IPL",
      canonical_url: "/sports/ipl",
      amp_url: "",
    },
    {
      id: "3",
      title: "Orange Cap",
      canonical_url: "/sports/ipl/orange-cap",
      amp_url: "",
    },
  ];

  return (
    <div>
      <HeadTag
        title={title}
        description={description}
        keywords={keywords}
        canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + canonical}
        noAuthorTag={false}
        image={categoryNewsListData?.seo_detail?.og_image}
        lcpImage={`${categoryNewsListData?.content?.[0]?.image_small}?size=360:203`}
      />
      <GTMScript isElection={true} />
      {/* <WebsiteSchema /> */}
      {/* <IPLFAQSchema /> */}
      <WebpageSchema
        title={title}
        description={description}
        keywords={keywords}
        canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + canonical}
      />
      <BreadcrumbSchema breadcrumbList={breadCrumbs} />

      <ItemsList
        data={
          categoryNewsListData?.length > 0
            ? [...categoryNewsListData?.content]
            : []
        }
      />
      <Breadcrumb breadcrumbList={breadCrumbs} />
      <MGIDAAdsScript delay={true} />
      <div className="mx-4">
        <AdSlot300x250
          divId="div-gpt-ad-1659434453897-0"
          minWidth="300px"
          minHeight="250px"
        />

        <AdSlot728x90
          divId="div-gpt-ad-1659424515060-0"
          minWidth="728px"
          minHeight="90px"
        />
      </div>

      {iplKeys?.showSponsor && (
        <IPLSponsor color="white" masterConfigKey={iplKeys} />
      )}
      <IPLMenu />

      <section className="px-4 py-2">
        <h1 className="text-lg font-semibold my-4">
          {year == 2025
            ? "IPL 2025 Orange Cap"
            : `IPL ${year} Orange Cap Winner`}
        </h1>
        {year=="2025"&&<p className={`text-[#323232] text-sm text-left relative inline mb-4`}>
          <span className={`${readMore ? "line-clamp-2" : "mb-2"}`}>
            IPL में हमेशा से हर बल्लेबाज का सपना ऑरेंज कैप हासिल करना रहा है. यह
            कैप उस बल्लेबाज को दी जाती है, जो सबसे ज्यादा रन बनाता है. इस कैप की
            खास बात यह है कि ये पूरे टूर्नामेंट के दौरान बदलती रहती है, जैसे ही
            कोई नया खिलाड़ी अधिक रन बनाता है. यह कैप उसके पास चले जाती है. मैच
            के दौरान केवल वही बल्लेबाज इस कैप को पहनकर मैदान में खेल सकता है,
            जिसके सबसे अधिक रन हैं. टूर्नामेंट के अंत में जिस बल्लेबाज को
            आधिकारिक रूप से यह कैप सौंपी जाती है. इस वर्ष अभी तक इस कैप के
            दावेदार LSG के निकोलस पूरन चल रहें हैं. 2024 में विराट कोहली ने इस
            कैप को हासिल किया था. डेविड वॉर्नर ने 3 बार यह कैप जीती है, जो IPL
            में अभी तक सबसे ज्यादा है. भारतीय खिलाड़ी विराट कोहली और वेस्टइंडीज
            के क्रिस गेल यह 2-2 बार जीत चुके हैं. IPL में अभी तक 10 बार विदेशी
            खिलाड़ियों ने और 7 बार भारतीय खिलाड़ियों ने इस कैप को हासिल किया है,
            ऑरेंज कैप विजेता 6 भारतीय खिलाड़ी हैं: सचिन तेंदुलकर, रॉबिन उथप्पा,
            विराट कोहली (2 बार विजेता), केएल राहुल, ऋतुराज गायकवाड़, और शुभमन
            गिल।
          </span>
          <span
              onClick={() => {
                setReadMore(prev=>!prev);
              }}
              className="cursor-pointer inline -ml-[0.5px]  text-primary text-sm"
            >
              {readMore?"और देखें >":"< कम देखें"}
            </span>
        </p>}
        <TopPlayerCard playerData={statData} playerType="orange_cap" />
        <IPLYearsCarousel
          matchData={iplYearsFilter}
          handleSelectYear={handleSelectYear}
          selectedYear={year || selectedYear}
          setTourId={setTourId}
        />
        {scrolled && (
          <div className="my-3">
            <AdSlot300x250
              divId={"div-gpt-ad-1659434604998-0"}
              minWidth="300px"
              minHeight="250px"
            />

            <AdSlot728x90
              divId={"div-gpt-ad-1707804176041-2"}
              minWidth="720px"
              minHeight="90px"
            />
          </div>
        )}

        <h2 className=" mx-3  my-4 font-semibold text-lg">
          IPL {selectedYear} In Numbers
        </h2>
        {/* batting stats table */}
        <div className="flex flex-col sm:flex-row items-center space-y-3 sm:space-y-0 sm:space-x-4 mx-3 my-2">
          {/* Dropdown Filter */}
          <select
            id="battingFilter"
            value={selectedBattingFilter}
            onChange={handleDropdownChange}
            className="border rounded p-2 w-full"
          >
            {battingFilter?.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>

          {/* Search Input with Icon Inside */}
          <div className="relative w-full">
            <input
              id="search"
              className="placeholder:italic placeholder:text-slate-400 block w-full bg-white border border-slate-300 rounded-md py-2 pl-3 pr-10 shadow-sm focus:outline-none"
              placeholder="Search by Player Name"
              type="text"
              name="search"
              value={searchByName}
              onChange={(e) => setSearchByName(e.target.value)}
            />

            {/* Search Icon Inside Input */}
            <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
              <img
                src="/assets/icons/svg/search.svg"
                alt="Search Icon"
                className="w-5 h-5 text-gray-500"
              />
            </div>
          </div>
        </div>

        <OrangeCapTable
          topBatPerformers={statData ?? []}
          selectedFilter={selectedBattingFilter}
          yearDataLoading={statData ? false : true}
          selectedYear={selectedYear}
        />
        {scrolled && (
          <div className="my-3">
            <AdSlot300x250
              divId={"div-gpt-ad-1659434785315-0"}
              minWidth="300px"
              minHeight="250px"
            />

            <AdSlot728x90
              divId={"div-gpt-ad-1707804176041-3"}
              minWidth="720px"
              minHeight="90px"
            />
          </div>
        )}
      </section>

      <div className="mx-4">
        <IPLCommonFooter
          categoryNewsListData={categoryNewsListData}
          faqData={faqData}
          isMobileDevice={isMobileDevice}
          showAds={false}
          scrolled={scrolled}
        />
        {scrolled && (
          <AdSlot300x250
            divId={"div-gpt-ad-1659435474737-0"}
            minWidth="300px"
            minHeight="250px"
          />
        )}

        {scrolled && (
          <AdSlot728x90
            divId="div-gpt-ad-1659425743360-0"
            minWidth="720px"
            minHeight="90px"
          />
        )}
      </div>
      <div data-type="_mgwidget" data-widget-id="1584885"></div>
      <script
        async
        dangerouslySetInnerHTML={{
          __html: `window.addEventListener("load", function() {
              (function(w,q){w[q]=w[q]||[];w[q].push(["_mgc.load"])})(window,"_mgq");
            });`,
        }}
      ></script>
    </div>
  );
};

export default OrangeCapPage;
